const { createApp } = require('vue');
import App from './App.vue';

// Wrap the createApp and mount calls in a setTimeout function
setTimeout(() => {
  createApp(App).mount('#app');
}, 2000); // Change the time (in milliseconds) as per your requirement
